import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2 } from "lucide-react";
import api from "@/lib/api";
import { Section, DeleteBtn } from "./common";

export default function EnquiriesList() {
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/enquiries");
      setItems(data);
    } catch {
      toast.error("Failed to load enquiries");
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <Section title={`Franchise enquiries (${items.length})`}>
      <ul className="divide-y divide-black/5" data-testid="admin-enquiries-list">
        {items.map((e) => (
          <li key={e.id} className="py-3 flex items-start justify-between gap-3" data-testid={`admin-enquiry-${e.id}`}>
            <div className="flex items-start gap-3 min-w-0">
              <span className="w-8 h-8 rounded-full bg-league-red/10 text-league-red flex items-center justify-center shrink-0 mt-0.5">
                <Building2 size={14} />
              </span>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-league-ink">{e.name} <span className="font-normal text-muted-foreground">— {e.phone}</span></p>
                {e.email && <p className="text-xs text-muted-foreground">{e.email}</p>}
                {e.message && <p className="text-xs text-league-ink/70 mt-1">"{e.message}"</p>}
              </div>
            </div>
            <DeleteBtn testid={`admin-enquiry-delete-${e.id}`} onClick={async () => { await api.delete(`/enquiries/${e.id}`).catch(() => toast.error("Delete failed")); load(); }} />
          </li>
        ))}
        {items.length === 0 && <li className="py-4 text-sm text-muted-foreground">No franchise enquiries yet — they arrive from the form on the Teams and Season 6 pages.</li>}
      </ul>
    </Section>
  );
}
